import { InvoiceStatusEnum } from '@/types'
import type { BadgeVariants, ButtonVariants } from '@/ui'

export const INVOICE_STATUS_TRANSITIONS: Record<
  InvoiceStatusEnum,
  {
    path: string
    subpath?: string
    options?: InvoiceStatusEnum[]
    label?: string
    variant?: ButtonVariants['variant']
  }
> = {
  [InvoiceStatusEnum.DRAFT]: {
    path: '',
    options: [InvoiceStatusEnum.PENDING, InvoiceStatusEnum.CANCELLED],
  },
  [InvoiceStatusEnum.PENDING]: {
    path: 'issue',
    variant: 'amber',
    label: 'Issue Invoice',
    options: [InvoiceStatusEnum.PAID, InvoiceStatusEnum.CANCELLED], // InvoiceStatusEnum.OVERDUE, InvoiceStatusEnum.PARTIALLY_PAID
  },
  [InvoiceStatusEnum.OVERDUE]: {
    path: '',
    variant: 'destructive',
    label: 'Overdue',
    options: [InvoiceStatusEnum.PAID, InvoiceStatusEnum.CANCELLED], // InvoiceStatusEnum.PARTIALLY_PAID,
  },
  [InvoiceStatusEnum.PAID]: {
    path: 'mark-paid',
    variant: 'accent',
    label: 'Mark as Paid',
    options: [InvoiceStatusEnum.REFUNDED], // InvoiceStatusEnum.PARTIALLY_PAID,
  },
  [InvoiceStatusEnum.PARTIALLY_PAID]: {
    path: '',
    variant: 'accent',
    label: 'Partially Paid',
    options: [InvoiceStatusEnum.PAID, InvoiceStatusEnum.CANCELLED, InvoiceStatusEnum.REFUNDED],
  },
  [InvoiceStatusEnum.CANCELLED]: {
    path: 'cancel',
    subpath: 'cancel-and-create-draft',
    variant: 'red',
    label: 'Cancel Invoice',
  },
  [InvoiceStatusEnum.REFUNDED]: {
    path: 'refund',
    variant: 'secondary',
    label: 'Refund Invoice',
  },
}

export const INVOICE_STATUS_COLORS: Record<InvoiceStatusEnum, BadgeVariants['variant']> = {
  [InvoiceStatusEnum.DRAFT]: 'secondary',
  [InvoiceStatusEnum.PENDING]: 'yellow',
  [InvoiceStatusEnum.OVERDUE]: 'destructive',
  [InvoiceStatusEnum.PAID]: 'green',
  [InvoiceStatusEnum.PARTIALLY_PAID]: 'blue',
  [InvoiceStatusEnum.CANCELLED]: 'red',
  [InvoiceStatusEnum.REFUNDED]: 'purple',
}

export const MOCK_INVOICE = {
  id: '01JVKYKCCA2G675F87VDNZ6Z14',
  number: 'INV-0000002',
  status: InvoiceStatusEnum.PAID,
  issued_at: '2025-05-19',
  due_at: '2025-06-18',
  total_formatted: '$250.00',
  items: [
    {
      name: 'Test item 1',
      quantity: 2,
      unit_formatted: '£100.00',
      subtotal_formatted: '€200.00',
      discount_formatted: '€11.00',
      total_formatted: '€189.00',
    },
    {
      name: 'Test item 2',
      quantity: 1,
      unit_formatted: '£51.00',
      subtotal_formatted: '€51.00',
      discount_formatted: '€1.00',
      total_formatted: '€50.00',
    },
  ],
}
